// extracted by mini-css-extract-plugin
export var boxcheckbox = "checkbox-module--boxcheckbox--b1ead";
export var boxcheckboxtoogle = "checkbox-module--boxcheckboxtoogle--3e387";
export var checkboxitem = "checkbox-module--checkboxitem--fba5f";
export var error = "checkbox-module--error--e971e";
export var errorToogle = "checkbox-module--errorToogle--ec2eb";
export var errors = "checkbox-module--errors--86e45";
export var itemChecboxToogle = "checkbox-module--itemChecboxToogle--2daeb";
export var legalText = "checkbox-module--legalText--0a959";
export var toogle = "checkbox-module--toogle--49cc0";